import { observer } from "mobx-react-lite";
import React, { useContext, useEffect } from "react";
import { Redirect } from "react-router";
import { Container, Jumbotron, Row } from "reactstrap";
import { RootStoreContext } from "../app/stores/rootStore";
import Loader from "../components/common/Loader";
import TenantListComponent from "../components/TenantListComponent";
import { clearAllBodyScrollLocks } from "body-scroll-lock";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../app/localization/localization";

const TenantSelectionLayout = () => {
  const rootStore = useContext(RootStoreContext);
  const { loadTenants, tenantArray } = rootStore.tenantStore;
  const [t] = useTranslation(["translation"], translationHookOptions);

  useEffect(() => {
    clearAllBodyScrollLocks();
    document.body.classList.remove("p-0");
    document.body.classList.add("form-membership");
  }, []);

  useEffect(() => {
    if (!tenantArray) {
      loadTenants().then(() => {});
    }
    return () => {};
  }, [loadTenants, tenantArray]);

  if (!tenantArray) return <Loader />;

  if (tenantArray.length === 1)
    return <Redirect to={  tenantArray[0].redirectDOC ? tenantArray[0].path + "/repository" :  tenantArray[0].path + "/meetings"} />;
 return (
    <Container>
      <Jumbotron className="form-wrapper w-100  mt-0">
        <h3 className="text-center font-weight-bold">{t("select_tenant")}</h3>
        <hr />
        <Row className="justify-content-center">
          {tenantArray && <TenantListComponent tenants={tenantArray} />}
        </Row>
      </Jumbotron>
    </Container>
  );
};

export default observer(TenantSelectionLayout);
